import { useSoonModal } from '../../ui/SoonModal/SoonModalContext';
import '../../ui/styles.css';
import './styles.css';

export function Topbar() {
  const { openSoonModal } = useSoonModal();

  return (
    <header className="topbar">
      <div className="container topbarInner">
        <a className="brand" href="#top">
          <span className="brandMark" aria-hidden="true">
            D
          </span>
          <span className="brandText">DaoCampus</span>
        </a>

        <nav className="nav">
          <a href="#features">Features</a>
          <a href="#how">How it Works</a>
          <a href="#projects">Projects</a>
          <a href="#universities">For Universities</a>
          <a href="#community">Community</a>
        </nav>

        <div className="topbarCtas">
          <button type="button" className="btn btnPrimary" onClick={openSoonModal}>
            Get Started
          </button>
        </div>
      </div>
    </header>
  );
}

